/* ============================================================
   LIFTSTAR THEME — theme.js
   © 2026 Liftstar. Tüm hakları saklıdır.
   Bağımlılık yok. Saf JavaScript.
   ============================================================ */
(function () {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const qs = (s, el) => (el || document).querySelector(s);
  const qsa = (s, el) => Array.from((el || document).querySelectorAll(s));

  const debounce = (fn, wait) => {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
  };

  /* ---------- Para formatı ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '{{amount}}';
    const value = (cents / 100);
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function num(n, precision, thousands, decimal) {
      const fixed = n.toFixed(precision);
      const parts = fixed.split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return precision ? int + decimal + parts[1] : int;
    }
    let out;
    switch ((format.match(placeholder) || [])[1]) {
      case 'amount': out = num(value, 2, ',', '.'); break;
      case 'amount_no_decimals': out = num(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = num(value, 2, "'", '.'); break;
      default: out = num(value, 2, ',', '.');
    }
    return format.replace(placeholder, out);
  }

  /* ---------- Overlay + Drawer yönetimi ---------- */
  const overlay = qs('[data-overlay]');
  let openDrawer = null;

  function drawerOpen(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (openDrawer && openDrawer !== el) drawerClose();
    openDrawer = el;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    document.body.classList.add('drawer-open');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(() => overlay.classList.add('is-active')); }
    const focusable = qs('input, button, a', el);
    if (focusable) focusable.focus({ preventScroll: true });
  }

  function drawerClose() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    openDrawer = null;
    document.body.classList.remove('drawer-open');
    if (overlay) {
      overlay.classList.remove('is-active');
      setTimeout(() => { if (!openDrawer) overlay.hidden = true; }, 300);
    }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      drawerOpen(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      if (closer.tagName !== 'A') e.preventDefault();
      drawerClose();
    }
  });
  if (overlay) overlay.addEventListener('click', drawerClose);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') drawerClose(); });

  /* ---------- Header gölgesi ---------- */
  const header = qs('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Sepet ---------- */
  const Cart = {
    sectionIds() {
      const ids = qsa('[data-cart-root][data-section-id]').map((el) => el.getAttribute('data-section-id'));
      return [...new Set(ids)];
    },

    renderSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach((id) => {
        qsa('[data-cart-root][data-section-id="' + id + '"]').forEach((root) => {
          const doc = new DOMParser().parseFromString(sections[id], 'text/html');
          const fresh = doc.querySelector('[data-cart-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
        });
      });
    },

    updateCount(count) {
      qsa('[data-cart-count]').forEach((el) => {
        el.setAttribute('data-count', count);
        const inner = el.querySelector('span') || el;
        inner.textContent = count;
      });
    },

    async refreshCount() {
      try {
        const cart = await fetch(T.routes.cart + '.js').then((r) => r.json());
        this.updateCount(cart.item_count);
      } catch (e) { /* sessiz geç */ }
    },

    async add(body, button) {
      const ids = this.sectionIds();
      if (ids.length) body.sections = ids;
      let res;
      try {
        res = await fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      } catch (e) { res = null; }

      if (!res || !res.ok) {
        let msg = T.strings.addError || 'Hata';
        if (res) { try { const j = await res.json(); msg = j.description || j.message || msg; } catch (e) {} }
        if (button) flashButton(button, msg, true);
        return false;
      }
      const data = await res.json();
      this.renderSections(data.sections);
      this.refreshCount();
      if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) drawerOpen('CartDrawer');
      return true;
    },

    async change(line, quantity) {
      const ids = this.sectionIds();
      const body = { line, quantity };
      if (ids.length) body.sections = ids;
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) return;
      const data = await res.json();
      this.renderSections(data.sections);
      this.updateCount(data.item_count);
    }
  };

  function flashButton(btn, text, isError) {
    const original = btn.getAttribute('data-label') || btn.textContent.trim();
    btn.setAttribute('data-label', original);
    btn.textContent = text;
    if (!isError) btn.classList.add('is-added');
    setTimeout(() => { btn.textContent = original; btn.classList.remove('is-added'); }, 2200);
  }

  /* Ürün formu (AJAX sepete ekle) */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = qs('[data-add-button]', form);
    const idInput = form.elements.namedItem('id');
    const qtyInput = form.elements.namedItem('quantity');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    Cart.add({ id: Number(idInput.value), quantity: qtyInput ? Number(qtyInput.value) : 1 }, btn)
      .then((ok) => {
        if (btn) {
          btn.removeAttribute('aria-disabled');
          if (ok && T.cartType !== 'drawer') window.location.href = T.routes.cart;
          else if (ok) flashButton(btn, '✓ ' + (btn.getAttribute('data-added-label') || 'Eklendi'));
        }
      });
  });

  /* Hızlı ekle */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    Cart.add({ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 }, btn)
      .then((ok) => {
        btn.removeAttribute('aria-disabled');
        if (ok) flashButton(btn, '✓ ' + (btn.getAttribute('data-added-label') || 'Eklendi'));
      });
  });

  /* Adet artır/azalt */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = qs('input', btn.closest('.qty'));
    if (!input) return;
    const step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    const min = Number(input.min || 1);
    input.value = Math.max(min, Number(input.value || 1) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Sepet satırı adet / silme (drawer + sayfa, delegasyon) */
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    Cart.change(Number(input.getAttribute('data-line-qty')), Number(input.value));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    Cart.change(Number(rm.getAttribute('data-line-remove')), 0);
  });

  /* ---------- Varyant seçici ---------- */
  qsa('[data-product-wrapper]').forEach((wrapper) => {
    const jsonEl = qs('[data-product-json]', wrapper);
    if (!jsonEl) return;
    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const form = qs('form[data-product-form]', wrapper);
    const idInput = form ? qs('[name="id"]', form) : null;
    const priceEl = qs('[data-price]', wrapper);
    const compareEl = qs('[data-compare-price]', wrapper);
    const btn = qs('[data-add-button]', wrapper);
    const btnLabel = btn ? qs('[data-add-label]', btn) || btn : null;

    function selectedOptions() {
      return qsa('.option', wrapper).map((opt) => {
        const checked = qs('input:checked', opt);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    function showMedia(mediaId) {
      if (!mediaId) return;
      const items = qsa('[data-media-id]', wrapper);
      if (!items.length) return;
      let found = false;
      items.forEach((item) => {
        const match = item.getAttribute('data-media-id') === String(mediaId);
        if (item.hasAttribute('data-media-main')) item.hidden = !match;
        if (match) found = true;
      });
      qsa('[data-thumb-media]', wrapper).forEach((th) => {
        th.classList.toggle('is-active', th.getAttribute('data-thumb-media') === String(mediaId));
      });
      if (!found) { const first = qs('[data-media-main]', wrapper); if (first) first.hidden = false; }
    }

    function update() {
      const variant = findVariant(selectedOptions());
      qsa('[data-option-value]', wrapper).forEach((el) => {
        const opt = el.closest('.option');
        const checked = qs('input:checked', opt);
        if (checked) el.textContent = checked.value;
      });
      if (!variant) {
        if (btn) { btn.setAttribute('aria-disabled', 'true'); if (btnLabel) btnLabel.textContent = T.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.hidden = false;
          compareEl.textContent = formatMoney(variant.compare_at_price);
          priceEl.closest('.price').classList.add('price--sale');
        } else {
          compareEl.hidden = true;
          priceEl.closest('.price').classList.remove('price--sale');
        }
      }
      if (btn) {
        if (variant.available) {
          btn.removeAttribute('aria-disabled');
          if (btnLabel) btnLabel.textContent = T.strings.addToCart;
        } else {
          btn.setAttribute('aria-disabled', 'true');
          if (btnLabel) btnLabel.textContent = T.strings.soldOut;
        }
      }
      if (variant.media_id) showMedia(variant.media_id);
      if (variant.id && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    wrapper.addEventListener('change', (e) => {
      if (e.target.closest('.option')) update();
    });

    /* Galeri küçük görselleri */
    qsa('[data-thumb-media]', wrapper).forEach((th) => {
      th.addEventListener('click', () => showMedia(th.getAttribute('data-thumb-media')));
    });
  });

  /* ---------- Arama + öneriler ---------- */
  const searchInput = qs('[data-search-input]');
  const predictive = qs('[data-predictive]');
  if (searchInput && predictive) {
    const run = debounce(async () => {
      const q = searchInput.value.trim();
      if (q.length < 2) { predictive.innerHTML = ''; return; }
      try {
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        const data = await fetch(url).then((r) => r.json());
        const products = (((data || {}).resources || {}).results || {}).products || [];
        if (!products.length) {
          predictive.innerHTML = '<p class="predictive__empty">' + (T.strings.noResults || '') + '</p>';
          return;
        }
        predictive.innerHTML = '<div class="predictive__grid">' + products.map((p) => {
          const img = p.featured_image && p.featured_image.url
            ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy" width="62" height="62">'
            : '<span style="width:62px;height:62px;background:var(--surface)"></span>';
          return '<a class="predictive__item" href="' + p.url + '">' + img +
            '<span><span class="predictive__title">' + p.title + '</span>' +
            '<span class="predictive__price">' + (p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a>';
        }).join('') + '</div>';
      } catch (e) { /* sessiz */ }
    }, 280);
    searchInput.addEventListener('input', run);
  }

  /* ---------- Koleksiyon sıralama ---------- */
  qsa('[data-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Reveal + hero ---------- */
  let revealObserver = null;
  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); revealObserver.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }

  function revealScan(scope) {
    const els = qsa('[data-reveal]:not(.is-revealed)', scope || document);
    els.forEach((el, i) => {
      if (!revealObserver) { el.classList.add('is-revealed'); return; }
      if (!el.style.getPropertyValue('--reveal-i')) {
        el.style.setProperty('--reveal-i', String(i % 6));
      }
      revealObserver.observe(el);
    });
  }

  revealScan(document);
  T.revealScan = revealScan;

  qsa('.hero').forEach((h) => requestAnimationFrame(() => h.classList.add('is-loaded')));
})();
